// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__22DYl","warning":"Input_warning__3IE5c","container":"Input_container__3X1zr","warningText":"Input_warningText__1-PyA"};